@for (post of posts; track post) {
  <tyt-post
    [post]="post"
    [compact]="true"
    [showParent]="false"
    [showAsTopLevel]="true"
    quickAction="like"
  ></tyt-post>
}
